module.exports = __webpack_public_path__ + "static/media/background.c1b2f4d4.jpg";